// Customers List Getters

export const getCustomersList = state => {
  return state.customersList
}

export const getCustomerInfo = state => {
  return state.customerInfo
}

export const getFullCustomersList = state => {
  return state.fullCustomersList
}

export const getSaleCustomersList = state => {
  return state.saleCustomersList
}
